import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import { SvgIcon } from '@/components';
import { TariffType } from '@/config';

import styles from './SaveBadge.module.sass';

interface SaveBadgeProps {
  isActive?: boolean;
  tariff: TariffType;
  value: number;
  className?: string;
}

const SaveBadge = ({ isActive, tariff, value, className }: SaveBadgeProps) => {
  // TODO: Add translation
  const { t } = useTranslation();

  const classes = cx(
    styles.badge,
    {
      [styles[tariff]]: !!tariff,
      [styles['is-active']]: isActive,
    },
    className,
  );

  return (
    <div className={classes}>
      <SvgIcon name="fire" />
      <span>Save {value}%</span>
    </div>
  );
};

export default SaveBadge;
